import { createContext } from "react";

import type { InferenceFormStore } from "./store";

// Note: The InferenceFormContext is unnecessary as a Zustand store can be used
// from anywhere and initialized once. It may be safely removed.
export const InferenceFormContext = createContext<InferenceFormStore | null>(
  null,
);
